import { createRoute, useNavigate, useSearch } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

interface AdminEmailSearch {
  /** Opens the editor in create mode (`?new=1`). */
  new?: boolean;
  /** Opens the editor for an existing template (`?edit=<id>`). */
  edit?: string;
}

function AdminEmailPage() {
  const search = useSearch({ from: "/_app/admin/email" });
  const navigate = useNavigate();

  // The template editor is deep-linkable (`?new=1` / `?edit=<id>`): the URL
  // is the source of truth, so an admin can share "edita esta plantilla".
  const openNew = (): void => {
    void navigate({ to: "/admin/email", search: { new: true }, replace: true });
  };
  const openEdit = (id: string): void => {
    void navigate({ to: "/admin/email", search: { edit: id }, replace: true });
  };
  const closeEditor = (): void => {
    void navigate({ to: "/admin/email", search: {}, replace: true });
  };

  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager
        creating={Boolean(search().new)}
        editingId={search().edit}
        onNew={openNew}
        onEdit={openEdit}
        onClose={closeEditor}
      />
    </PageContainer>
  );
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  validateSearch: (search: Record<string, unknown>): AdminEmailSearch => ({
    // Include the NUMBER 1: TanStack auto-parses `?new=1` as number 1 (not string);
    // without this case the param was discarded during boot and the dialog did not open
    // via deep link (CC-18).
    new:
      search.new === true || search.new === 1 || search.new === "1" || search.new === "true"
        ? true
        : undefined,
    edit: typeof search.edit === "string" && search.edit.trim() !== "" ? search.edit : undefined,
  }),
  component: AdminEmailPage,
});
